"use client"; 

import { useState } from 'react'
import SectionMoreButton from '../common/sectionMoreButton';
import AutomationsGridItem from './automationsGridItem';


export default function AutomationsGrid(params) {
  const { 
    externalAutomations=[], 
    chunk=3, 
    showMore=false, 
    showEmpty=false, 
  } = params


  const [page, setPage] = useState(1)  // Using to load more apps
  const externalAutomationsVisible = externalAutomations?.slice(0, page*chunk)

  return (
    <div className="space-y-6">
      
      {showEmpty && externalAutomationsVisible?.length === 0 && (
        <div className="py-24 text-center w-full">
          <p className="text-4xl font-extrabold tracking-tight text-gray-700">
            Sorry, no automations found
          </p>
          <p className="mt-4 max-w-3xl mx-auto text-base text-gray-500">
            Try to refine your search
          </p>
        </div>
      )}
      
      {/* External Automations */}
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-3 gap-4">              
        {externalAutomationsVisible?.map(extAutomation => (
          <div key={extAutomation?.id} className="col-span-1">
            <AutomationsGridItem extAutomation={extAutomation} />
          </div>
        ))}

      </div>
    
      {showMore && (page*chunk < externalAutomations?.length) && (
        <SectionMoreButton 
          onClick={() => setPage(page + 1)}
          title="Show more  "
        /> 
      )}

    </div>
  )
}
